import React, { useEffect, useState } from 'react'

import Paragraph from '../../atoms/Paragraph'
import Charts from '../Charts'
import { colorSet } from './index.data'

interface Props {
  content: any
}

const ChartBlock = ({ content }: Props) => {
  const [chartData, setChartData] = useState<any>({})
  const [chartType, setChartType] = useState(content.chartType ? content.chartType : 'bar')
  const [isPercentageValue, setIsPercentageValue] = useState(false)
  const [pieChartLabels, setPieChartLabels] = useState([])

  useEffect(() => {
    if (!content.referenceName) {
      return
    } else {
      setChartType(content.chartType)
      content.referenceName.map((richTextData) => {
        if (richTextData.fields.chartDetails) {
          richTextData.fields.chartDetails.content.map((richText) => {
            return extractTableDataFromRichtext(
              richText,
              richTextData?.fields?.disclaimer,
              richTextData?.fields?.chartName,
            )
          })
        }
        return null
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, content.referenceName)

  const getChartsData = (tableData, disclaimer, chartName) => {
    let labels = []
    const datasets = []
    if (tableData.length === 0) return { labels: [], datasets: [] }
    if (chartType === 'doughnut' || chartType === 'pie') {
      const data = []
      const pieLabels = []
      tableData.forEach((row) => {
        labels.push(row[0] + ' ' + row[2])
        data.push(row[1])
        pieLabels.push({
          label: row[0],
          value: row[1],
          range: row[2],
        })
      })
      datasets.push({
        label: ['Pie Chart'],
        data: data.map((el) => {
          const isPercentage = /%/.test(el)
          setIsPercentageValue(isPercentage)
          return parseFloat(el).toString() || ''
        }),
      })
      setPieChartLabels(pieLabels)
    } else {
      labels = tableData.slice(1).map((row) => row[0])

      for (let i = 1; i < tableData[0].length; i++) {
        datasets.push({
          label: tableData[0][i],
          data: tableData.slice(1).map((row) => {
            const isPercentage = /%/.test(row[i])
            setIsPercentageValue(isPercentage)
            return parseFloat(row[i]).toString() || ''
          }),
        })
      }
    }

    return { labels, datasets, disclaimer, chartName }
  }

  const extractTableDataFromRichtext = (richtextData, disclaimer, chartName) => {
    const tableNodes = richtextData.nodeType === 'table'
    if (!richtextData || !tableNodes) return []
    const tableData = richtextData.content.map((row) => {
      return row.content.map((cell) => {
        const paragraph = cell?.content?.[0]

        return paragraph?.nodeType === 'paragraph' && paragraph.content?.[0]?.nodeType === 'text'
          ? paragraph.content[0].value
          : ''
      })
    })
    setChartData(getChartsData(tableData, disclaimer, chartName))

    return tableData
  }

  return (
    <div className="w-full">
      {/* {content?.headline && (
            <Headings variant="h4" content={content?.headline} />
          )}
          {content.description && (
            <Paragraph content={content.description} classes="mb-24" />
          )} */}
      {/* Check Table Data */}
      {/* <Paragraph
            content={documentToHtmlString(
              content.referenceName[0].fields.chartDetails
            )}
          /> */}
      {chartType === 'doughnut' || chartType === 'pie' ? (
        <>
          <div className="flex flex-wrap">
            <div className="w-full md:w-40">
              <Charts type={chartType} data={chartData} isPercentageValue={isPercentageValue} />
            </div>
            <div className="mt-32 flex w-full items-center px-16 md:mt-0 md:w-1/2 md:px-48">
              <div className="w-full">
                {pieChartLabels.length &&
                  pieChartLabels.map((item, index) => {
                    return (
                      <div className="flex items-center justify-between py-1 text-sm" key={`key-${index}`}>
                        <span className="flex w-2/3 items-center">
                          <span
                            className="mr-3 inline-block h-5 w-5 rounded-full"
                            style={{
                              backgroundColor: colorSet[index],
                            }}
                          ></span>
                          {item.label}
                        </span>
                        <span className="flex w-2/4 justify-between">
                          <span>{item.value}</span>
                          <span>{item.range}</span>
                        </span>
                      </div>
                    )
                  })}
              </div>
            </div>
          </div>
          {chartData?.disclaimer && <Paragraph content={chartData?.disclaimer} classes="!text-sm mt-32" />}
        </>
      ) : (
        <Charts type={chartType} data={chartData} isPercentageValue={isPercentageValue} />
      )}
    </div>
  )
}

export default ChartBlock
